import EvcHormuudPaymentForm from "@/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx";
import { linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { LinkMethod } from "@/modules/billing/paymentMethods.ts";
import type { EvcHormuudConfig } from "@warrenio/api-spec/spec.oats.gen";

export function makeEvcHormuudLink(config: EvcHormuudConfig) {
    return config.methods.map((method): LinkMethod => {
        const base = linkDefaults(config, method);
        return {
            ...base,
            // Payment is initiated outside of Warren (eg. EVC Mobile Money app), Hormuud notifies us about the transaction
            isInstructionsOnly: true,
            PaymentForm: (props) => <EvcHormuudPaymentForm {...props} fee={base.fee} />,
        };
    });
}
